<template>
  <div class="flex flex-column">
    <div class="flex gap-1" style="justify-content: end;">
      <k-button :theme-color="'success'" @click="handleOpenSingleAddForm(true)">
        <span>Add new Row</span>
      </k-button>
      <settings-dropdown :theme-color="'primary'" :items="settings" @itemclick="onSettingsItemClick">
        <span class="k-icon k-i-more-vertical k-icon-24"></span>
      </settings-dropdown>
    </div>

    <csvloader
      :hitAddNewData="hitAddNewData"
      :changeHitAddNewData="handleOpenSingleAddForm"
      :downloadCSV="downloadCSV"
      @updateDownloadCSVValue="(value) => downloadCSV = value"
    ></csvloader>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Button } from "@progress/kendo-vue-buttons";
// import KendoDropDownCompat from "@/components/shared/KendoDropDownCompat.vue";
import { DropDownButton } from "@progress/kendo-vue-buttons";
import csvLoader2 from "../components/csvLoader2/index.vue";

export default defineComponent({
  name: "csv-loader",
  components: {
    csvloader: csvLoader2,
    "settings-dropdown": DropDownButton,
    "k-button": Button,
  },
  data() {
    return {
      settings: [
        {
          text: "Import",
        },
        {
          text: "Export",
        },
      ],
      invoiceId:'',
      activeTab: 0,
      hitAddNewData: false,
      downloadCSV: false,
      loader: false,
      exportId: 10,
    };
  },

  created() {
   this.loader = this.$route.query.loader === "true";
    this.invoiceId = this.$route.query.invoiceId || '';
    document.title = "EzzyBills CSV"
  },

  methods: {
    onSettingsItemClick(event) {
      console.log("Dropdown item clicked:", event);
      event.item.text === "Import" ?
      this.$router.push(`/CSVLoader2/Import2?invoiceId=${this.invoiceId}`)
      : this.export();
    },
    handleOpenSingleAddForm(flag) {
      this.hitAddNewData = flag;
    },
    async export() {
      this.downloadCSV = true;
    },
  },
});
</script>